import { useSelector } from "react-redux";
const useFeatureAccessibility = (guardName) => {
  const guards = useSelector((state) => state == null ? void 0 : state.session.guards);
  return guardName ? guards == null ? void 0 : guards[guardName] : guards;
};
export default useFeatureAccessibility;
